// extracted by mini-css-extract-plugin
module.exports = {"styledProvider":"ReactPlayground-StyledProvider-module--styled-provider--A3Tfd"};